// src/services/offers.js

import api from "./api";

/**
 * Fetches all data required for the Overview page.
 */
export async function getOffers(outletUid) {

    try {

        const response = await api.get(

            "/api/v1/nextgo/offers",

            {

                params: {

                    outletUid,

                },

            }

        );

        return response.data;

    }

    catch (error) {

        console.error(

            "Failed to fetch offers:",

            error

        );

        throw error;

    }

}

export async function createOffer(offer) {

    const formData = new FormData();

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    formData.append(

        "outletUid",

        outletUid

    );

    formData.append(
        "title",
        offer.title
    );

    formData.append(
        "image",
        offer.image
    );

    formData.append(
        "discountType",
        offer.discountType
    );

    formData.append(
        "discountValue",
        offer.discountValue
    );

    formData.append(
        "minimumPurchaseAmount",
        offer.minimumPurchaseAmount
    );

    formData.append(
        "validFrom",
        offer.validFrom
    );

    formData.append(
        "validTo",
        offer.validTo
    );

    const response = await api.post(

        "/api/v1/nextgo/create-offer",

        formData,

        {

            headers: {

                "Content-Type": "multipart/form-data",

            },

        }

    );

    return response.data;

}